export const FACEBOOK_AND_INSTAGRAM_FIELDS_TO_DISABLE = [
  'facebookAndInstagramLocation',
  'costCenter'
];
